export default __webpack_public_path__ + "static/media/Artist4.ea2304c4.svg";